import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class DatacenterDetailsService {


    private storageDetailsApi: String = '/hybridity/api/vc/';

    constructor(public http: HttpClient) {
    }

    getDatacenterStorageConsumedDetails(dcId: string, vcId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.storageDetailsApi + vcId + '/datacenter/' + dcId + '/storageConsumed')
        ;
    }

    getClusterStorageConsumedDetails(clusterId: string, vcId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.storageDetailsApi + vcId + '/cluster/' + clusterId + '/storageConsumed')
        ;
    }
    getComputeResourceStorageConsumedDetails(computeResourceId: string, vcId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.storageDetailsApi + vcId + '/computeResource/' + computeResourceId +
             '/storageConsumed')
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/datacenter/datacenter-details-vc.service.ts